import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class CandidateInstructionService {

 
  private path = '/candidate-instructions';

  constructor(
    private backendService: BackendService
  ) { }


  saveCandidateInstruction(instruction) {
    return this.backendService.post(this.path , instruction);
  }

  getCandidateInstructionById(testid,langid) {
    return this.backendService.get(this.path +'/tests/' + testid + "/langs/" + langid);
 }

 getDashboard (){
  return this.backendService.get(this.path + "/condition/dashboard");
}

 
}
